<template>
    <div>
        <div class="header-title">
            <div class="header-img">
                <img v-if="logoUrl" :src="logoUrl"/>
            </div>

            <div class="menu-icon">
                <a href="javascript:void(0);" v-on:click="showToggle"><img src="@/../static/index_qiehuan.png" width="21px" height="18px"/></a>
            </div>
        </div>

        <div class="menu-box" :class="{'show':isShow, 'hide':!isShow}">
            <div class="menu">
                <div class="menu-item" v-for="item in menus" v-bind:key="item.menuId">
                    <a :href="item.mobileMenuUrl" v-if="item.subMenus.length == 0">{{item.menuName}}</a>
                    <a href="javascript:void(0);" v-else >{{item.menuName}}</a>
                    <div class="sub-menu" v-if="item.subMenus.length > 0" >
                        <div class="menu-item" v-for="subItem in item.subMenus" v-bind:key="subItem.menuId">
                            <a :href="subItem.mobileMenuUrl">{{subItem.menuName}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.header-title{
    height: 44px;
    position: relative;
}
.header-img{
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
}
.header-img img{
    height: 30px;
    width: 108px;
    margin-left: 12px;
}
.menu-icon{
    position: absolute;
    right: 12px;
    top:12px;
}
.show{
    display: block;
}
.hide{
    display: none;
}
.menu-box{
    margin: 0 auto;
    background-color: #C92A3A;
    color: white;
    font-size: 18px;
    line-height: 36px;
    border-bottom: 2px solid #E95A6F;
    z-index: 200;
}
.menu{
}
.menu-item{
    padding-left: 42px;
    cursor: pointer;
    background-color: #C92A3A;
    position: relative;
}
.menu-item:hover{
    color: #E95A6F;
}
.sub-menu{
    z-index: 100;
}
.sub-menu .menu-item{
    
    border-left: 1px solid  #E95A6F;
}
a{
    color: white;
}
a:visited{
    color: white;
}
</style>

<script>
export default {
    name: 'HeadTitle',
    data(){
        return {
            isShow:false
        }
    },
    props:{
        logoUrl:{
            type:String,
            default:''
        },
        menus:{
            type:Array,
            default:[]
        }
    },
    methods:{
        showToggle(){
            this.isShow = !this.isShow;
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/MobileMenu.vue